// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"defaultButton_defaultButton__1IyYJ"};